import {SimulcastRtmpValidator} from "./SimulcastRtmpValidator";
import {CreateOrEditType} from "../../util/common/CreateOrEditType";
import {FBLocationType} from "../../extplat/facebook/Facebook";
import {ExtPlatAuth} from "../../extplat/ExtPlatAuth";
import {IngestionType, PrivacyStatus} from "../../extplat/youtube/Youtube";

interface ISimulcastAllData {
    core: ISimulcastCoreData,
    fb: ISimulcastFBData,
    mpegts: ISimulcastMpegtsData,
    rtmp: ISimulcastRtmpData,
    yt: ISimulcastYTData
}

enum SimulcastType {
    Rtmp = "rtmp",
    Facebook = "facebook",
    Youtube = "youtube",
    SRT = "srt"
}

enum SimulcastStatusType {
    Stopped = "stopped",
    Started = "started"
}

enum SimulcastErrorAction {
    TryAgainLater,
    Reconnect,
    Delete
}

interface ISimulcastCoreData {
    simulcastId: number;
    mediaId: number;
    extPlatAuthId: number | null;
    simulcastStatusType: SimulcastStatusType;
    simulcastType: SimulcastType;
    title: string | null;
    descShort: string | null;
    label: string,
    lastErrorCreated: number | null;
    lastErrorHttpStatusCode: number | null;
    lastErrorSafeMsg: string | null;
    userUpdated: number;
    updated: number;
    retry: boolean,
    stopOnInputLoss: boolean;
}

// interface ISimulcastCoreData {
//     simulcastId: number;
//     mediaId: number;
//     simulcastType: SimulcastType;
//     simulcastStatusType: SimulcastStatusType;
//     label: string,
//     lastErrorCreated: number | null;
//     lastErrorHttpStatusCode: number | null;
//     lastErrorSafeMsg: string | null;
//     userUpdated: number;
//     updated: number;
//     retry: boolean,
//     stopOnInputLoss: boolean;
// }

interface ISimulcastFBData {
    fbLiveVideoId: string | null;
    fbStreamUrl: string | null;
    fbLocationId: string | null;
    fbLocationLabel: string | null;
    fbLocationType: FBLocationType | null;
    fbPrivacyTypeId: number | null;
    fbPlannedStartTime: number | null;
    fbSaveVod: boolean;
    fbPageAccessToken: string | null;
}


// START YOUTUBE

interface ISimulcastYTCreateReq {
    label: string;
    title: string | null;
    descShort: string | null;
    extPlatAuthId: number;
    retry: boolean;
    yt: ISimulcastYTCreateYTReq;

}

interface ISimulcastYTCreateYTReq {
    ytOwnerId: string | null;
    ytOwnerDisplayName: string | null;
    ytChannelId: string | null;
    ytChannelTitle: string | null;
    ytBrCdEnableDVR: boolean;
    ytBrCdEnableEmbed: boolean;
    ytBrCdEnableAutoStart: boolean;
    ytBrCdEnableAutoStop: boolean;
    ytBrCdEnableClosedCaptions: boolean;
    ytBrCdEnableContentEncryption: boolean;
    ytBrCdRecordFromStart: boolean;
    ytBrSnScheduledStartTime: number | null;
    ytBrStPrivacyStatus: PrivacyStatus;
    ytStreamCdIsReusable: boolean;
    ytStreamCdnIngestionType: string;
}

interface ISimulcastYTUpdateReq {
    label: string;
    title: string | null;
    descShort: string | null;
}

interface ISimulcastYTData{
    general: ISimulcastYTGeneralData;
    broadcast: ISimulcastYTBroadcastData,
    stream:ISimulcastYTStreamData
}

interface ISimulcastYTGeneralData{
    ytOwnerId: string | null;
    ytOwnerDisplayName: string | null;
    ytChannelId: string | null;
    ytChannelTitle: string | null;
}

interface ISimulcastYTBroadcastData{
    ytBrId: String | null;
    ytBrCdEnableAutoStart: boolean;
    ytBrCdEnableAutoStop: boolean;
    ytBrCdEnableClosedCaptions: boolean;
    ytBrCdEnableContentEncryption: boolean;
    ytBrCdEnableDVR: boolean;
    ytBrCdEnableEmbed: boolean;
    ytBrCdRecordFromStart: boolean;
    ytBrSnLiveChatId: string | null;
    ytBrSnPublishedAt: string | null;
    ytBrSnScheduledStartTime: number | null;
    ytBrSnScheduledEndTime: number | null;
    ytBrStPrivacyStatus: PrivacyStatus | null
}

interface ISimulcastYTStreamData{
    ytStreamId: string | null;
    ytStreamCdnIngestionType: IngestionType | null;
    ytStreamCdnIInfoStreamName: string | null;
    ytStreamCdnIInfoIngestionAddress: string | null;
    ytStreamCdnIInfoRtmpsIngestionAddress: string | null;
}

// END YOUTUBE


// interface ISimulcastFBData {
//     fbLiveVideoId: string | null;
//     fbStreamUrl: string | null;
//     fbAccountName: string | null;
//     fbStreamTypeId: number | null;
//     fbLocationId: string | null;
//     fbLocationLabel: string | null;
//     fbPrivacyTypeId: number | null;
//     fbPlannedStartTime: number | null;
//     fbSaveVod: boolean;
// }

interface ISimulcastMpegtsData {
    mpegtsUdpHost: string | null;
    mpegtsUdpPort: number | null;
}

interface ISimulcastRtmpData {
    rtmpServerUrl: string | null;
    rtmpStreamKey: string | null;
    rtmpUser: string | null;
    rtmpPass: string | null;
}

interface ISimulcastFBCreateReq {
    label: string;
    title: string | null;
    descShort: string | null;
    extPlatAuthId: number;
    fbLocationId: string;
    fbLocationLabel: string;
    fbLocationType: FBLocationType;
    fbPageAccessToken: string | null;
    fbPrivacyTypeId: number | null;
    fbPlannedStartTime: number | null;
    fbSaveVod: boolean;
    retry: boolean;
}

interface ISimulcastFBUpdateReq {
    label: string;
    title: string | null;
    descShort: string | null;
}

// interface ISimulcastFBUpdateReq {
//     label: string;
//     //fbStreamTypeId: number | null;
//     fbLocationId: string | null;
//     fbLocationLabel: string | null;
//     fbLocationType: string | null;
//     fbPageAccessToken: string | null;
//     fbPrivacyTypeId: number | null;
//     fbPlannedStartTime: number | null;
//     fbSaveVod: boolean;
//     retry: boolean;
// }

interface ISimulcastRtmpUpdateReq {
    label: string,
    retry: boolean;
    rtmpServerUrl: string;
    rtmpStreamKey: string;
    rtmpUser: string | null;
    rtmpPass: string | null;
}

interface IRtmpSimulcastEditData {
    simulcast: ISimulcastAllData;
    validator: SimulcastRtmpValidator;
    createOrEdit: CreateOrEditType;
}

interface IFacebookSimulcastEditData {
    simulcast: ISimulcastAllData;
    createOrEdit: CreateOrEditType;
}

interface IFacebookSimulcastReconnectData {
    simulcast: ISimulcastAllData;
    extPlatAuth: ExtPlatAuth;
}

interface IYoutubeSimulcastEditData {
    simulcast: ISimulcastAllData;
    createOrEdit: CreateOrEditType;
}



export {
    ISimulcastAllData,
    ISimulcastCoreData,
    ISimulcastFBData,
    ISimulcastRtmpData,
    ISimulcastMpegtsData,
    SimulcastType,
    SimulcastStatusType,
    ISimulcastFBCreateReq,
    ISimulcastFBUpdateReq,
    ISimulcastRtmpUpdateReq,
    ISimulcastYTCreateReq,
    ISimulcastYTCreateYTReq,
    ISimulcastYTUpdateReq,
    ISimulcastYTData,
    IRtmpSimulcastEditData,
    IFacebookSimulcastEditData,
    IFacebookSimulcastReconnectData,
    IYoutubeSimulcastEditData,
    SimulcastErrorAction
}